module.exports = __webpack_public_path__ + "fonts/TheSansVeolia-W7Bld.adb9e159.otf";